import React, { useEffect, useState } from "react";

import { getCommonConfig, updateCommonConfig } from "@/services/commonconfig";

const AppTourConfig: React.FC = () => {
  const [inactive, setInactive] = useState(0);
  const [tourIcon, setTourIcon] = useState(true);

  const [initial, setInitial] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await getCommonConfig();
    setInactive(res.InactiveDays);
    setTourIcon(res.TourIcon);
    setInitial(JSON.stringify(res));
  };

  const hasChanges =
    initial !== "" &&
    JSON.stringify({
      InactiveDays: inactive,
      TourIcon: tourIcon,
    }) !==
      JSON.stringify({
        InactiveDays: JSON.parse(initial).InactiveDays,
        TourIcon: JSON.parse(initial).TourIcon,
      });

  const handleSave = async () => {
    setSaving(true);

    const parsed = JSON.parse(initial);

    await updateCommonConfig({
      LogoutTime: parsed.LogoutTime,
      WarningTime: parsed.WarningTime,
      InactiveDays: inactive,
      TourIcon: tourIcon,
      NotificationIcon: parsed.NotificationIcon,
      LanguageSwitchIcon: parsed.LanguageSwitchIcon,
    });

    setInitial(
      JSON.stringify({
        ...parsed,
        InactiveDays: inactive,
        TourIcon: tourIcon,
      })
    );

    setSaving(false);
  };

  const handleCancel = () => {
    const parsed = JSON.parse(initial);
    setInactive(parsed.InactiveDays);
    setTourIcon(parsed.TourIcon);
  };

  return (
    <div className="border border-gray-200 rounded-md bg-[#fbfaf7] p-3 space-y-3">
      <div className="flex items-center gap-4 text-xs">
        <span className="w-40 text-gray-700">Inactive Days</span>
        <input
          type="number"
          className="w-24 border border-gray-300 px-2 py-1 rounded focus:ring-2 focus:ring-orange-400"
          value={inactive}
          onChange={(e) => setInactive(Number(e.target.value))}
        />
      </div>

      <div className="flex items-center gap-4 text-xs">
        <span className="w-40 text-gray-700">Tour Icon</span>

        <div className="flex border border-gray-300 rounded overflow-hidden">
          <button
            className={`px-3 py-1 text-xs ${
              tourIcon ? "bg-[var(--color-brand)]  text-white" : "bg-gray-100 text-gray-600"
            }`}
            onClick={() => setTourIcon(true)}
          >
            Show
          </button>
          <button
            className={`px-3 py-1 text-xs ${
              !tourIcon ? "bg-[var(--color-brand)]  text-white" : "bg-gray-100 text-gray-600"
            }`}
            onClick={() => setTourIcon(false)}
          >
            Hide
          </button>
        </div>
      </div>

      <div className="flex justify-end gap-2 items-center">
        {hasChanges && (
          <div className="text-orange-600 border border-orange-300 bg-orange-50 px-2 py-0.5 rounded text-xs">
            Unsaved
          </div>
        )}

        <button
          className="bg-[#e7e5e0] px-3 py-1 rounded text-xs"
          onClick={handleCancel}
          disabled={!hasChanges}
        >
          Cancel
        </button>

        <button
          className="bg-[var(--color-brand)]  text-white px-3 py-1 rounded text-xs"
          onClick={handleSave}
          disabled={!hasChanges || saving}
        >
          {saving ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default AppTourConfig;
``;
